import ReactDOM from 'react-dom/client';

import App from 'app/App';
import 'styles/styles.scss';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
